import {TripTypes} from '../js/constants.js'

export const tripTypeAction = (context, tripType) => {
  context.commit('tripType', tripType);
  if (tripType === TripTypes.PlaceAirport) {
    context.commit('placeByType', {id: context.state.defaultPlaceId, placeType: 'to', description: 'Airport'});
    context.commit('placeByType', {id: null, placeType: 'from'});
  } else if (tripType === TripTypes.AirportPlace) {
    context.commit('placeByType', {id: context.state.defaultPlaceId, placeType: 'from', description: 'Airport'});
    context.commit('placeByType', {id: null, placeType: 'to'});
  } else if (tripType === TripTypes.PlacePlace) {
    context.commit('placeByType', {id: null, placeType: 'to'});
    context.commit('placeByType', {id: null, placeType: 'from'});
  }
}

export const formatFormExtras = (context) => {
  let formExtras = [];
  for (let [key, extra] of Object.entries(context.state.extrasByIdTrip)) {
    if (extra.quantity > 0) {
      formExtras.push({id: extra.id, trip: extra.trip, quantity: extra.quantity, name: extra.name});
    }
  }
  context.commit('formExtras', formExtras);
}
